import React from 'react';

export function EventsPage() {
  return (
    <iframe
      src='https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23F09300&ctz=America%2FLos_Angeles&src=Y19mdGVzcWw3czE5dDE5a3Y3Mmsxbjc2M29wb0Bncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23D50000'
      width='100%'
      height='100%'
      // frameborder='0'
      scrolling='no'
    ></iframe>
  );
}
